import React from 'react';
import { useTranslation } from 'react-i18next';

const M7TipContent = () => {
  const { t } = useTranslation();
  return (
    <p>{t('m7Tip')}</p>
  );
};

export default M7TipContent;
